import { getMessages } from '../../../../../../../store/constants';

export const BOARD_BUTTON_COPY = getMessages().getText('board_settings.actions.copy');
